export default "__VITE_ASSET__Y6mgV1L$__"